import React from "react";
import { Navigate } from "react-router-dom";

const VendorRoute = ({ element: Component, ...rest }) => {
	const isVendor = localStorage.getItem("vendorId");
	return !isVendor ? <Component {...rest} /> : <Navigate to="/dashboard" />;
};

export default VendorRoute;
